export const AwardDialogPage = {
  Review: "review",
  Award: "award"
};